module.exports = __webpack_public_path__ + "img/public/SiteIcons/steering-3.png?91c0cc98";